export default __webpack_public_path__ + "static/media/confluence-logo.59910298.png";